import { render, staticRenderFns } from "./ScreenLaudoMorfologica1Trimestre.vue?vue&type=template&id=1d0ff33b&lang=true&"
import script from "./ScreenLaudoMorfologica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoMorfologica1Trimestre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports